import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WarehousingLabelPrintService {

  async printOrDownload(blob: Blob, filename: string): Promise<'printed' | 'downloaded'> {
    const browserPrint = (window as Window & { BrowserPrint?: any }).BrowserPrint;
    if (browserPrint?.getDefaultDevice) {
      try {
        const zpl = await blob.text();
        const printed = await new Promise<boolean>(resolve => {
          browserPrint.getDefaultDevice('printer',
            (device: any) => {
              if (!device?.send) {
                resolve(false);
                return;
              }
              device.send(zpl, () => resolve(true), () => resolve(false));
            },
            () => resolve(false));
        });
        if (printed) {
          return 'printed';
        }
      } catch {
        // Fall back to file download below.
      }
    }

    this.downloadBlob(blob, filename);
    return 'downloaded';
  }

  private downloadBlob(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
  }
}
